<template>
    <div>
        <h3>{{videoTitle}}</h3>
        <div class='resp-container' v-bind:style="{height:height}">
            <youtube class='resp-iframe' v-bind:video-id="videoId" ref="youtube" @playing="playing"></youtube>
        </div>
        <div>
            <button
                    v-for="data in videoTimeTags"
                    v-bind:key="data.text"
                    :video-id="data.videoId"
                    :videoTitle="data.videoTitle" v-on:click="playVideoPeriod(data.time)">{{data.description}}
            </button>
        </div>
        <p></p>
    </div>
</template>

<script>
    export default {
        name: "YoutubeVideo",
        props: {
            videoId: String,
            videoTitle: String,
            videoTimeTags: Array
        },
        data() {
            return {
                // width * 90% * 80% * youtube default ratio - 10px (padding/margin)
                height: ((window.innerWidth * 0.9 * 0.8)* 9 / 16 - 10  + "px")
            }
        },
        methods: {
            playVideo() {
                this.player.playVideo()
            },
            playVideoPeriod(timeSeconds) {
                this.player.seekTo(timeSeconds, true);
                this.player.playVideo();

            },
            playing() {
                console.log('we are watching...');
            }
        },
        computed: {
            player() {
                return this.$refs.youtube.player
            }
        }
    }
</script>

<style scoped>

    .resp-container {
        position: relative;
        width: 80%;
        margin: auto;
    }

    .resp-iframe {
        width: 100%;
        height: 100%;
        border: 0;
    }

    button {
        background: white;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 10px;
        letter-spacing: 1px;
        font-family: "Open Sans", sans-serif;
        font-weight: 400;
        min-width: 140px;
        margin-top: 8px;
        color: #8b8c8d;
        cursor: pointer;
        border: 1px solid #DDDEDF;
        text-transform: uppercase;
        transition: 0.1s all;
        font-size: 10px;
        outline: none;

    /*&:hover {*/
    /*     border-color: mix(#DDDEDF, black, 90%);*/
    /*     color: mix(#8b8c8d, black, 80%);*/
    /* }*/
    }

</style>
